export default {
  title: 'Update your password',
  text: "In our latest update, we've changed our password requirements. You must therefore update your profile below with a new password which must contain:",

  updatePasswordButton: 'Update password',
  updatePasswordLoadingButton: 'Updating password...',

  successToast: 'Your code has been updated'
}